import React from 'react';
import { toAbsoluteUrl } from '../../utils';
import { ForgotPasswordConfirmFormOld } from '../../components/forgot-password/ForgotPasswordConfirmFormOld';
import { LoginLayout } from '../../components/login/LoginLayout';
import { RedirectToLogin } from '../../components/login/RedirectToLogin';

import './ConfirmForgotPassword.scss';

export const ConfirmForgotPassword = (): JSX.Element => {

	return (
		<LoginLayout>
			<div className="forgot-password-right-column position-relative">
				<div className="forgot-password-form-wrapper">
					{/* Logo and App Name */}
					<div className="forgot-password-app-logo mb-10">
						<img
							className="logo-medium"
							src={toAbsoluteUrl('/media/flex-logo-small.svg')}
							alt="Flex"
						/>
					</div>

					<ForgotPasswordConfirmFormOld />

					<RedirectToLogin
						additionalClass="text-center mt-3"
						backButton
					/>
				</div>
			</div>
		</LoginLayout>
	);
};
